import React, { useState, useEffect } from 'react';
import './GestionAbsencesRetards.css';
import DashboardHeader from '../../components/DashboardHeader';
import AdminNavigationBar from '../../components/AdminNavigationBar';
import { CalendarIcon, UsersIcon, AlertIcon, ClockIcon } from '../../components/Icons';

function GestionAbsencesRetards() {
  const [absences, setAbsences] = useState([]);
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState({
    total_absences: 0,
    total_retards: 0,
    non_justifiees: 0,
    par_trimestre: {}
  });
  
  const [filters, setFilters] = useState({
    trimestre: '',
    type: '',
    classe: '',
    date_debut: '',
    date_fin: ''
  });

  useEffect(() => {
    fetchAbsences();
    fetchStatistiques();
  }, [filters]);

  const fetchAbsences = async () => {
    try {
      setLoading(true);
      
      const params = new URLSearchParams();
      if (filters.trimestre) params.append('trimestre', filters.trimestre);
      if (filters.type) params.append('type', filters.type);
      if (filters.classe) params.append('classe', filters.classe);
      if (filters.date_debut) params.append('date_debut', filters.date_debut);
      if (filters.date_fin) params.append('date_fin', filters.date_fin);

      const response = await fetch(`http://127.0.0.1:8000/api/v1/admin/absences?${params}`);
      const data = await response.json();
      
      setAbsences(data.data || data.absences || []);
      setLoading(false);
    } catch (error) {
      console.error('Erreur lors du chargement des absences:', error);
      setLoading(false);
    }
  };

  const fetchStatistiques = async () => {
    try {
      const params = new URLSearchParams();
      if (filters.trimestre) params.append('trimestre', filters.trimestre);
      if (filters.classe) params.append('classe', filters.classe);
      if (filters.date_debut) params.append('date_debut', filters.date_debut);
      if (filters.date_fin) params.append('date_fin', filters.date_fin);

      const response = await fetch(`http://127.0.0.1:8000/api/v1/admin/absences/statistiques?${params}`);
      const data = await response.json();
      
      setStats(data);
    } catch (error) {
      console.error('Erreur lors du chargement des statistiques:', error);
    }
  };

  const handleFilterChange = (e) => {
    setFilters({
      ...filters,
      [e.target.name]: e.target.value
    });
  };

  const resetFilters = () => {
    setFilters({
      trimestre: '',
      type: '',
      classe: '',
      date_debut: '',
      date_fin: ''
    });
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('fr-FR', { 
      day: '2-digit', 
      month: '2-digit', 
      year: 'numeric' 
    });
  };

  const getTypeLabel = (type) => {
    return type === 'absent' ? 'Absence' : 'Retard';
  };

  const getStatutBadge = (statut) => {
    const badges = {
      'signale': { label: 'Signalé', class: 'warning' },
      'justifie': { label: 'Justifié', class: 'success' },
      'non_justifie': { label: 'Non justifié', class: 'danger' }
    };
    
    const badge = badges[statut] || badges['signale'];
    return <span className={`statut-badge ${badge.class}`}>{badge.label}</span>;
  };

  if (loading) {
    return (
      <div className="admin-layout">
        <DashboardHeader />
        <AdminNavigationBar 
          title="Gestion des Absences & Retards" 
          onBack={() => window.navigateTo && window.navigateTo('admin-dashboard')}
        />
        <div className="admin-container">
          <main className="admin-content admin-content-full">
            <div className="loading-state">Chargement...</div>
          </main>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-layout">
      <DashboardHeader />
      <AdminNavigationBar 
        title="Gestion des Absences & Retards" 
        onBack={() => window.navigateTo && window.navigateTo('admin-dashboard')}
      />
      
      <div className="admin-container">
        <main className="admin-content admin-content-full">
          
          {/* Statistiques */}
          <div className="stats-grid">
            <div className="stat-card absences">
              <div className="stat-icon">
                <AlertIcon size={32} />
              </div>
              <div className="stat-content">
                <p className="stat-label">Total Absences</p>
                <h3 className="stat-value">{stats.total_absences || 0}</h3>
              </div>
            </div>

            <div className="stat-card retards">
              <div className="stat-icon">
                <ClockIcon size={32} />
              </div>
              <div className="stat-content">
                <p className="stat-label">Total Retards</p>
                <h3 className="stat-value">{stats.total_retards || 0}</h3>
              </div>
            </div>

            <div className="stat-card non-justifiees">
              <div className="stat-icon">
                <AlertIcon size={32} />
              </div>
              <div className="stat-content">
                <p className="stat-label">Non Justifiées</p>
                <h3 className="stat-value">{stats.non_justifiees || 0}</h3>
              </div>
            </div>

            <div className="stat-card total">
              <div className="stat-icon">
                <UsersIcon size={32} />
              </div>
              <div className="stat-content">
                <p className="stat-label">Total</p>
                <h3 className="stat-value">{(stats.total_absences || 0) + (stats.total_retards || 0)}</h3>
              </div>
            </div>
          </div>

          {/* Filtres */}
          <div className="filters-section">
            <h3>Filtres</h3>
            <div className="filters-grid">
              <div className="filter-group">
                <label>Trimestre</label>
                <select name="trimestre" value={filters.trimestre} onChange={handleFilterChange}>
                  <option value="">Tous les trimestres</option>
                  <option value="Trimestre 1">Trimestre 1</option>
                  <option value="Trimestre 2">Trimestre 2</option>
                  <option value="Trimestre 3">Trimestre 3</option>
                </select>
              </div>

              <div className="filter-group">
                <label>Type</label>
                <select name="type" value={filters.type} onChange={handleFilterChange}>
                  <option value="">Tous</option>
                  <option value="absent">Absences</option>
                  <option value="retard">Retards</option>
                </select>
              </div>

              <div className="filter-group">
                <label>Classe</label>
                <input 
                  type="text" 
                  name="classe" 
                  value={filters.classe} 
                  onChange={handleFilterChange}
                  placeholder="Ex: Seconde A"
                />
              </div>

              <div className="filter-group">
                <label>Date début</label>
                <input 
                  type="date" 
                  name="date_debut" 
                  value={filters.date_debut} 
                  onChange={handleFilterChange}
                />
              </div>

              <div className="filter-group">
                <label>Date fin</label>
                <input 
                  type="date" 
                  name="date_fin" 
                  value={filters.date_fin} 
                  onChange={handleFilterChange}
                />
              </div>

              <div className="filter-actions">
                <button className="btn-reset" onClick={resetFilters}>
                  Réinitialiser
                </button>
              </div>
            </div>
          </div>

          {/* Table des absences */}
          <div className="absences-table-card">
            <div className="table-header">
              <h3>Liste des absences et retards</h3>
              <button className="btn-refresh" onClick={fetchAbsences}>🔄</button>
            </div>

            <div className="table-wrapper">
              <table className="absences-table">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Élève</th>
                    <th>Classe</th>
                    <th>Matière</th>
                    <th>Type</th>
                    <th>Trimestre</th>
                    <th>Professeur</th>
                    <th>Statut</th>
                    <th>Heure</th>
                  </tr>
                </thead>
                <tbody>
                  {absences.length === 0 ? (
                    <tr>
                      <td colSpan="9" className="no-data">
                        Aucune absence ou retard trouvé
                      </td>
                    </tr>
                  ) : (
                    absences.map((absence) => (
                      <tr key={absence.id}>
                        <td>{formatDate(absence.date)}</td>
                        <td className="student-name">
                          {absence.etudiant ? 
                            `${absence.etudiant.prenom} ${absence.etudiant.nom}` : 
                            'N/A'
                          }
                        </td>
                        <td>{absence.classe || 'N/A'}</td>
                        <td><span className="matiere-badge">{absence.matiere || 'N/A'}</span></td>
                        <td>
                          <span className={`type-badge ${absence.type}`}>
                            {getTypeLabel(absence.type)}
                          </span>
                        </td>
                        <td>{absence.trimestre || 'N/A'}</td>
                        <td className="teacher-name">
                          {absence.enseignant ? 
                            `${absence.enseignant.prenom} ${absence.enseignant.nom}` : 
                            'N/A'
                          }
                        </td>
                        <td>{getStatutBadge(absence.statut)}</td>
                        <td>{absence.heure_arrivee || '-'}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}

export default GestionAbsencesRetards;
